import styled from "styled-components";

import { Wrapper } from "src/organization/common/components/activities/Activity/ActivityTitle/ActivityTitle.styles";

export const ActivityGroup = styled.g<{ activityType?: string }>`
  line {
    transition:
      stroke-width,
      stroke 0.2s ease-in-out;
    stroke: var(--theme-neutral-200);
    cursor: pointer;
    opacity: 0.9;
    stroke-width: 1px;
    border-radius: 360px;
    :hover {
      stroke: var(--icon-slate-fill, var(--slate));
      stroke-width: 2px;
    }
  }
`;

export const Layout = styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
`;

export const Activity = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  user {
    font-weight: 600;
  }
`;

export const ActivityIcon = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  g {
    fill: currentColor;
  }
  path {
    fill: var(--mode-vector-neutral-default);
  }
`;

export const ActivityTitle = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  max-width: 242px;
  a {
    text-decoration: none;
    font-weight: 600;
    color: var(--section-night-color, var(--night));
  }

  ${Wrapper} {
    max-width: 242px;
  }
`;
